module.exports = __webpack_public_path__ + "img/avatar_2.0afdad6c.png";